// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2L1_9","legacyBtn":"MutateMid_legacyBtn__2X5iw"};